export const getOptionsForPointModal = (openDataName) => {
  switch (openDataName) {
    case "occupancyType":
      return [
        {
          label: "Primary Residence",
          value: "Primary"
        },
        {
          label: "Second Home",
          value: "Secondary"
        },
        {
          label: "Rental or Investment Property",
          value: "Rental"
        },
      ];
    case "propertyType":
      return [
        {
          label: "Single Family",
          value: "Single"
        },
        {
          label: "Townhouse",
          value: "Townhome"
        },
        {
          label: "Condo",
          value: "Condo"
        },
        {
          label: "Duplex",
          value: "Duplex"
        },
        {
          label: "Triplex",
          value: "Triplex"
        },
        {
          label: "Quadplex",
          value: "Quadplex"
        },
      ];
    case "firstTimeBuyer":
      return [
        {
          label: "Yes",
          value: "false",
        },
        {
          label: "No",
          value: "true",
        },
      ];
    case "vaFirstTimeUse":
      return [
        {
          label: "Yes",
          value: false
        },
        {
          label: "No",
          value: true
        }
      ];
    case "isUsCitizen":
    case "isVeteran":
    case "isSelfEmployed":
    case "takeCashOut":
    case "disabledVeteran":
    case "lookAtVaLoans":
      return [
        {
          label: "Yes",
          value: true
        },
        {
          label: "No",
          value: false
        }
      ]
    case "hasRealEstateAgent":
    case "isBuyingAsIs":
    case "forSaleByOwner":
    case "hasTitleCompany":
    case "hasWaivedEscrow":
      return [
        {
          label: "Yes",
          value: "Yes"
        },
        {
          label: "No",
          value: "No"
        },
        {
          label: "Not Sure",
          value: "Not Sure"
        }
      ];
    default:
      return [];
  }
}
